import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import Swal from "sweetalert2";
import { RemoteResetUserPassword } from "../../../data/usecases/user-management/remote-reset-user-password";
import { ResetUserPassword } from "../../../domain/useages/user-management/reset-user-password";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface ResetUserPasswordInterface {
  resetUserPassword: Function;
}

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useResetUserPasswordSlice: StateCreator<
  ResetUserPasswordInterface
> = (set, get) => ({
  resetUserPassword: async (
    id: number,
    payload: ResetUserPassword.Params,
    handleClose: Function
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteResetUserPassword = new RemoteResetUserPassword(
      `${BASE_URL}${Endpoints.RESET_USER_MANAGEMEMT_PASSWORD}`,
      axiosHttpClient
    );
    let result = await remoteResetUserPassword.reset(id.toString(), payload);

    if (result) {
      handleClose();
    }
  },
});
